import { useState } from 'react';

export default function useDeletableRows(showDelete, onDeleteRow) {
  const [confirmDeleteIndex, setConfirmDeleteIndex] = useState(null);
  const hideConfirmDelete = () => setConfirmDeleteIndex(null);
  const isBeingDeleted = index => confirmDeleteIndex === index;
  const showConfirmDelete = index => {
    setConfirmDeleteIndex(index);
  };

  return { hideConfirmDelete, isBeingDeleted, showConfirmDelete, onDeleteRow, showDelete };
}
